/* eslint-disable no-mixed-spaces-and-tabs */
import React from 'react';
import {
	Typography,
	TableContainer,
	Table,
	TableBody,
	TableRow,
	TableCell,
	Paper,
} from '@mui/material';
// import { policyHeadCells } from '@/utils/constants';
import { FolioTableHead } from '@/components/table/FolioTableHead';
import { InsightClaimRow } from './InsightClaimRow';
import { useGetInsightClaimQuery } from '@/features/claims/ticketsApi';
import { useObjectContext } from '@/hooks/useObjectContext';

const headerCells = [
	{
		id: 'policyNumber',
		numeric: false,
		label: 'Policy No. Class of Risk',
		align: 'left',
		sortable: false,
	},
	{
		id: 'dateLoss',
		numeric: false,
		label: 'Date of loss',
		align: 'left',
		sortable: false,
	},
	{
		id: 'description',
		numeric: false,
		label: 'Description',
		align: 'left',
		sortable: false,
	},
	{
		id: 'insurer',
		numeric: false,
		label: 'Insurer',
		align: 'left',
		sortable: false,
	},
];

export const InsightClaimTable = () => {
	const { dealId } = useObjectContext();
	const { data: insightClaim } = useGetInsightClaimQuery(dealId, {
		skip: !dealId,
	});
	const claim = insightClaim ?? {};

	return (
		<>
			<TableContainer component={Paper}>
				<Table
					aria-labelledby='tableTitle'
					size='medium'
					aria-label='enhanced table'
					sx={{ minWidth: 700 }}
				>
					<FolioTableHead order={'desc'} orderBy={'createdate'} headCells={headerCells} />
					<TableBody>
						{claim ? (
							<InsightClaimRow claim={claim} />
						) : (
							<TableRow>
								<TableCell colSpan={headerCells.length} align='center'>
									<Typography variant='subtitle1'>No claims found</Typography>
								</TableCell>
							</TableRow>
						)}
					</TableBody>
				</Table>
			</TableContainer>
		</>
	);
};
